import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { CardsApi } from '@shared/api/rest';
import type { CardResponse, CardsRequest } from '@shared/api/rest/cards';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const getUserCardsEffect = createEffect((params: IQueryParams<CardsRequest>) => CardsApi.getCards(params.request, params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<CardResponse[]>([])
  .on(getUserCardsEffect.done, (current, data) => data.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getUserCardsEffect.pending, (_, data) => data)
  .on(getUserCardsEffect.fail, () => false)
  .on(getUserCardsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getUserCardsEffect, () => null)
  .on(getUserCardsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getUserCardsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $cardsListStore = {
  events: {
    getUserCards: ApiUtils.wrapperApi(getUserCardsEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
